import React from 'react';

/**
 * MatchStatusControl - Compact single-line version
 */
export const MatchStatusControl = ({
  match,
  lineupStatus,
  onStartMatch,
  onEndMatch,
  onCancelMatch,
  onNavigateToLineup,
  clockRunning = false,
  captainsAssigned = false
}) => {
  if (!match) return null;

  const lineupsComplete = lineupStatus && 
    lineupStatus.homeTeam.starting >= 11 && 
    lineupStatus.awayTeam.starting >= 11;

  const getStatusColor = () => {
    switch(match.status) {
      case 'scheduled': return 'bg-gray-100 text-gray-700';
      case 'live': return 'bg-green-100 text-green-700';
      case 'finished': return 'bg-blue-100 text-blue-700';
      default: return 'bg-red-100 text-red-700';
    }
  };

  const showWarnings = match.status === 'scheduled' && (!lineupsComplete || !captainsAssigned);

  return (
    <div className="bg-white rounded-lg shadow-sm p-3 mb-4">
      <div className="flex items-center justify-between gap-3">
        {/* Status Badge */}
        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor()}`}>
          {match.status.toUpperCase()}
        </span>

        {/* Warnings */}
        {showWarnings && (
          <div className="flex items-center gap-2 text-xs text-yellow-700">
            {!lineupsComplete && (
              <span title="Incomplete lineups">⚠️ Lineups</span>
            )}
            {!captainsAssigned && (
              <span title="Missing captains">👨‍✈️ Captains</span>
            )}
          </div>
        )}

        {/* Action Buttons - Compact */}
        <div className="flex gap-2 ml-auto">
          {match.status === 'scheduled' && (
            <button
              onClick={onStartMatch}
              className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
            >
              🟢 Start
            </button>
          )}

          {match.status === 'live' && (
            <button
              onClick={() => {
                if (clockRunning) {
                  alert('Stop clock first');
                  return;
                }
                onEndMatch();
              }}
              className="px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700"
            >
              ⏹️ End
            </button>
          )}

          <button
            onClick={onCancelMatch}
            disabled={match.status === 'finished' || match.status === 'cancelled'}
            className="px-3 py-1 bg-red-600 text-white rounded text-xs hover:bg-red-700 disabled:bg-gray-300"
          >
            🚫 Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
